import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import { theme, withReducedMotion } from "../../theme";
import { MODAL_ENTER_DURATION, MODAL_EXIT_DURATION } from "./animation-constants";
import { noop } from "../../utils/noop";
import { useId } from '@react-aria/utils';
import { DialogContainer } from "./DialogContainer";
var SIZES = {
  'x-small': '288px',
  small: '360px',
  medium: '480px',
  large: '800px'
};
export function Dialog(_ref) {
  var initialFocusRef = _ref.initialFocusRef,
      isShowing = _ref.isShowing,
      children = _ref.children,
      _ref$onRequestClose = _ref.onRequestClose,
      onRequestClose = _ref$onRequestClose === void 0 ? noop : _ref$onRequestClose,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? theme.zIndices.modal : _ref$zIndex,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$enableClickOutsi = _ref.enableClickOutsideToClose,
      enableClickOutsideToClose = _ref$enableClickOutsi === void 0 ? true : _ref$enableClickOutsi,
      other = _objectWithoutProperties(_ref, ["initialFocusRef", "isShowing", "children", "onRequestClose", "zIndex", "size", "enableClickOutsideToClose"]);

  var id = useId();
  return /*#__PURE__*/React.createElement(DialogContainer, {
    initialFocusRef: initialFocusRef,
    isShowing: isShowing,
    onRequestClose: onRequestClose,
    zIndex: zIndex,
    enableClickOutsideToClose: enableClickOutsideToClose
  }, function (ref, state) {
    return /*#__PURE__*/React.createElement(StyledDialog, _extends({
      "aria-modal": "true",
      role: "dialog",
      ref: ref,
      tabIndex: -1,
      "data-state": state,
      "aria-labelledby": id,
      $size: size
    }, other), children);
  });
}
var eases = theme.transitions.eases;
export var dialogAnimations = css(["transition:transform ", "ms ", ",opacity ", "ms ", ";transform:scale(0.96);&[data-state='entering'],&[data-state='entered']{opacity:1;transform:scale(1);}&[data-state='exiting'],&[data-state='exited']{opacity:0;transition-duration:", "ms;transform:scale(0.96);}", ";"], MODAL_ENTER_DURATION, eases.primary, MODAL_ENTER_DURATION, eases.primary, MODAL_EXIT_DURATION, withReducedMotion(css(["transform:scale(1);&[data-state='exiting'],&[data-state='exited']{transform:scale(1);}"])));
export var baseDialogMargins = css(["margin:", " auto;", "{margin:", " auto;}@media screen and (min-height:", "){margin:128px auto;}"], theme.spaces[8], theme.mediaQueries.tablet, theme.spaces[64], theme.breakpoints.tablet);
export var baseDialogStyles = css(["pointer-events:auto;background:", ";border-radius:", ";border:1px solid ", ";outline:none;width:calc(100vw - ", ");will-change:transform;", "{width:", ";max-width:100%;}"], theme.colors.background.secondary, theme.radii[8], theme.colors.border.secondary, theme.spaces[16], theme.mediaQueries.tablet, function (p) {
  return SIZES[p.$size];
});
export var StyledDialog = styled.div.withConfig({
  displayName: "Dialog__StyledDialog",
  componentId: "vapor__sc-16qlq81-0"
})(["", ";", ";", ";"], baseDialogStyles, dialogAnimations, baseDialogMargins);